
import { Component, PropSync, Vue } from 'vue-property-decorator'
import DateDialog from "@/components/DateAndTime/DateDialog.vue"
import TimeDialog from "@/components/DateAndTime/TimeDialog.vue"
import { DateAndTimeHelper } from "@/helpers/DateAndTimeHelper"

@Component({
  components: {
    TimeDialog,
    DateDialog
  }
})
export default class StartingTime extends Vue {
  @PropSync('startedAt', { type: Number }) started!: number;

  private dateDialog = false
  private timeDialog = false
  private dateAndTimeHelper = new DateAndTimeHelper()

  private get readableDate () {
    if (!this.started) {
      return
    }
    return this.dateAndTimeHelper.getReadableDateFromStartingTime(this.started)
  }

  private get readableTime () {
    if (!this.started) {
      return
    }
    const date = new Date(this.started)
    return this.twoDigits(date.getHours()) + ':' + this.twoDigits(date.getMinutes())
  }

  private updateStartingDate (startingDate: number) {
    const newDate = this.dateAndTimeHelper.getNewMillisecondsDate(this.started, startingDate)
    this.$emit('changedDate', newDate)
    this.dateDialog = false
  }

  private updateStartingTime (startingTime: string) {
    const startedAtDateAndTime = this.dateAndTimeHelper.getMillisecondsFromTimeValue(this.started, startingTime)
    this.$emit('changedTime', startedAtDateAndTime)
    this.timeDialog = false
  }

  private twoDigits (value: any) {
    if (value.toString().length <= 1) {
      return '0' + value.toString()
    }
    return value.toString()
  }
}
